// export const semanticTokens = {
//     colors: {
//       // ===== Background =====
//       "bg":               { default: "white",      _dark: "gray.900" },
//       "bg.subtle":        { default: "gray.50",    _dark: "gray.800" },
//       "bg.muted":         { default: "gray.100",   _dark: "gray.700" },
//       "bg.emphasized":    { default: "gray.200",   _dark: "gray.600" },
//       "bg.inverted":      { default: "black",      _dark: "white" },
//       "bg.panel":         { default: "white",      _dark: "gray.800" },
//       "bg.error":         { default: "red.50",     _dark: "red.900" },
//       "bg.warning":       { default: "orange.50",  _dark: "orange.900" },
//       "bg.success":       { default: "green.50",   _dark: "green.900" },
//       "bg.info":          { default: "blue.50",    _dark: "blue.900" },

//       // ===== Border =====
//       "border":           { default: "gray.200",   _dark: "gray.700" },
//       "border.subtle":    { default: "gray.100",   _dark: "gray.800" },
//       "border.muted":     { default: "gray.50",    _dark: "gray.900" },
//       "border.emphasized":{ default: "gray.300",   _dark: "gray.600" },
//       "border.inverted":  { default: "black",      _dark: "white" },
//       "border.error":     { default: "red.50",     _dark: "red.800" },
//       "border.warning":   { default: "orange.50",  _dark: "orange.800" },
//       "border.success":   { default: "green.50",   _dark: "green.800" },
//       "border.info":      { default: "blue.50",    _dark: "blue.800" },

//       // ===== Text / Foreground =====
//       "fg":               { default: "black",      _dark: "gray.50" },
//       "fg.muted":         { default: "gray.600",   _dark: "gray.400" },
//       "fg.subtle":        { default: "gray.400",   _dark: "gray.500" },
//       "fg.inverted":      { default: "gray.50",    _dark: "black" },
//       "fg.error":         { default: "red.500",    _dark: "red.300" },
//       "fg.warning":       { default: "orange.600", _dark: "orange.300" },
//       "fg.success":       { default: "green.600",  _dark: "green.300" },
//       "fg.info":          { default: "blue.600",   _dark: "blue.300" },

//       // ===== Gray palette =====
//       "gray.contrast":    { default: "white",    _dark: "gray.900" },
//       "gray.fg":          { default: "gray.800", _dark: "gray.100" },
//       "gray.subtle":      { default: "gray.100", _dark: "gray.800" },
//       "gray.muted":       { default: "gray.200", _dark: "gray.700" },
//       "gray.emphasized":  { default: "gray.300", _dark: "gray.600" },
//       "gray.solid":       { default: "gray.900", _dark: "gray.100" },
//       "gray.focusRing":   { default: "gray.800", _dark: "gray.200" },

//       // ===== Red palette =====
//       "red.contrast":     { default: "white",   _dark: "red.900" },
//       "red.fg":           { default: "red.700", _dark: "red.100" },
//       "red.subtle":       { default: "red.100", _dark: "red.800" },
//       "red.muted":        { default: "red.200", _dark: "red.700" },
//       "red.emphasized":   { default: "red.300", _dark: "red.600" },
//       "red.solid":        { default: "red.600", _dark: "red.600" },
//       "red.focusRing":    { default: "red.600", _dark: "red.600" },

//       // ===== Pink palette =====
//       "pink.contrast":    { default: "white",   _dark: "pink.900" },
//       "pink.fg":          { default: "pink.700", _dark: "pink.100" },
//       "pink.subtle":      { default: "pink.100", _dark: "pink.800" },
//       "pink.muted":       { default: "pink.200", _dark: "pink.700" },
//       "pink.emphasized":  { default: "pink.300", _dark: "pink.600" },
//       "pink.solid":       { default: "pink.600", _dark: "pink.600" },
//       "pink.focusRing":   { default: "pink.600", _dark: "pink.600" },

//       // ===== Purple palette =====
//       "purple.contrast":  { default: "white",   _dark: "purple.900" },
//       "purple.fg":        { default: "purple.700", _dark: "purple.100" },
//       "purple.subtle":    { default: "purple.100", _dark: "purple.800" },
//       "purple.muted":     { default: "purple.200", _dark: "purple.700" },
//       "purple.emphasized":{ default: "purple.300", _dark: "purple.600" },
//       "purple.solid":     { default: "purple.600", _dark: "purple.600" },
//       "purple.focusRing": { default: "purple.600", _dark: "purple.600" },

//       // ===== Cyan palette =====
//       "cyan.contrast":    { default: "white",   _dark: "cyan.900" },
//       "cyan.fg":          { default: "cyan.700", _dark: "cyan.100" },
//       "cyan.subtle":      { default: "cyan.100", _dark: "cyan.800" },
//       "cyan.muted":       { default: "cyan.200", _dark: "cyan.700" },
//       "cyan.emphasized":  { default: "cyan.300", _dark: "cyan.600" },
//       "cyan.solid":       { default: "cyan.600", _dark: "cyan.600" },
//       "cyan.focusRing":   { default: "cyan.600", _dark: "cyan.600" },

//       // ===== Blue palette =====
//       "blue.contrast":    { default: "white",   _dark: "blue.900" },
//       "blue.fg":          { default: "blue.700", _dark: "blue.100" },
//       "blue.subtle":      { default: "blue.100", _dark: "blue.800" },
//       "blue.muted":       { default: "blue.200", _dark: "blue.700" },
//       "blue.emphasized":  { default: "blue.300", _dark: "blue.600" },
//       "blue.solid":       { default: "blue.600", _dark: "blue.600" },
//       "blue.focusRing":   { default: "blue.600", _dark: "blue.600" },

//       // ===== Teal palette =====
//       "teal.contrast":    { default: "white",   _dark: "teal.900" },
//       "teal.fg":          { default: "teal.700", _dark: "teal.100" },
//       "teal.subtle":      { default: "teal.100", _dark: "teal.800" },
//       "teal.muted":       { default: "teal.200", _dark: "teal.700" },
//       "teal.emphasized":  { default: "teal.300", _dark: "teal.600" },
//       "teal.solid":       { default: "teal.600", _dark: "teal.600" },
//       "teal.focusRing":   { default: "teal.600", _dark: "teal.600" },

//       // ===== Green palette =====
//       "green.contrast":   { default: "white",   _dark: "green.900" },
//       "green.fg":         { default: "green.700", _dark: "green.100" },
//       "green.subtle":     { default: "green.100", _dark: "green.800" },
//       "green.muted":      { default: "green.200", _dark: "green.700" },
//       "green.emphasized": { default: "green.300", _dark: "green.600" },
//       "green.solid":      { default: "green.600", _dark: "green.600" },
//       "green.focusRing":  { default: "green.600", _dark: "green.600" },

//       // ===== Yellow palette =====
//       "yellow.contrast":  { default: "black",   _dark: "yellow.900" },
//       "yellow.fg":        { default: "yellow.700", _dark: "yellow.100" },
//       "yellow.subtle":    { default: "yellow.100", _dark: "yellow.800" },
//       "yellow.muted":     { default: "yellow.200", _dark: "yellow.700" },
//       "yellow.emphasized":{ default: "yellow.300", _dark: "yellow.600" },
//       "yellow.solid":     { default: "yellow.300", _dark: "yellow.300" },
//       "yellow.focusRing": { default: "yellow.300", _dark: "yellow.300" },

//       // ===== Orange palette =====
//       "orange.contrast":  { default: "black",   _dark: "orange.900" },
//       "orange.fg":        { default: "orange.700", _dark: "orange.100" },
//       "orange.subtle":    { default: "orange.100", _dark: "orange.800" },
//       "orange.muted":     { default: "orange.200", _dark: "orange.700" },
//       "orange.emphasized":{ default: "orange.300", _dark: "orange.600" },
//       "orange.solid":     { default: "orange.600", _dark: "orange.600" },
//       "orange.focusRing": { default: "orange.600", _dark: "orange.600" },
//     },
//   };
// // Standard Chakra color palette
// export const colors = {
//   gray: {
//     50: "#F7FAFC",
//     100: "#EDF2F7",
//     200: "#E2E8F0",
//     300: "#CBD5E0",
//     400: "#A0AEC0",
//     500: "#718096",
//     600: "#4A5568",
//     700: "#2D3748",
//     800: "#1A202C",
//     900: "#171923",
//   },
//   brand: {
//     50: "#E3FCEC",
//     100: "#C6F6D5",
//     200: "#9AE6B4",
//     300: "#68D391",
//     400: "#48BB78",
//     500: "#38A169",
//     600: "#2F855A",
//     700: "#276749",
//     800: "#22543D",
//     900: "#1C4532",
//   },
// };

import { useMemo } from 'react'

export const DEFAULT_TOKEN_PALETTE = [
  'cyan.emphasized',
  'blue.emphasized',
  'green.emphasized',
  'orange.emphasized',
  'red.emphasized',
  'purple.emphasized',
  'pink.emphasized',
  'teal.emphasized',
  'gray.emphasized',
]

interface SeriesLike {
  color?: string
}

export function useSeriesFills<T extends SeriesLike>(series: T[] = [], colors?: string[]) {
  return useMemo(() => {
    return series.map(
      (s, i) => s.color ?? colors?.[i] ?? DEFAULT_TOKEN_PALETTE[i % DEFAULT_TOKEN_PALETTE.length]
    )
  }, [series, colors])
}

/**
 * Converts a Chakra color token (e.g. "blue.subtle") to a usable CSS variable reference
 * (e.g. "var(--chakra-colors-blue-subtle)").
 *
 * Works for all Chakra UI 3 semantic or palette tokens, including custom theme tokens.
 * Use this when passing tokens to non-Chakra components (e.g. Recharts, Framer Motion).
 */
// export const toCssVar = (token: string): string => {
//   if (!token) return "";
//   return `var(--chakra-colors-${token.replace(/\./g, "-")})`;
// };

export const toCssVar = (v: any) =>
  typeof v === 'string' && !/^#|^rgb|^hsl|^var\(/i.test(v)
    ? `var(--chakra-colors-${v.replace(/\./g, '-')})`
    : v
